import { useOptionalVersioning } from '@/data/context/VersioningContext';
import Lesson from '@/models/Lesson';

export const useEditableLesson = (lessonId: number) => {
  const session = useOptionalVersioning<Lesson>();
  const runEditable = <R>(action: (lessonId: number) => Promise<R>) =>
    session
      ? session.runEditable(lesson => action(lesson.id))
      : action(lessonId);
  return { runEditable };
};
